import { Button, Col, Divider, Row } from "antd"
import { Input } from "components/form"
import dayjs from "dayjs"
import * as Yup from "yup"

export const EXPENSE_HOME_MENU = {
    MY_EXPENSE: "myExpense",
    FINANCIAL: "financial",
    ALL_EXPENSE: "allExpense"
}

export const EXPENSE_MENU = {
    HOME: "home",
    EXPENSE_REPORT: "expenseReport",
    TRAVEL_REPORT: "travelReport"
}
export const EXPENSE_PAGE = {
    HOME: "home",
    EXPENSE_REPORT: "expenseReport",
    TRAVEL_REPORT: "travelReport"
}

export const EXPENSE_ACTION = {
    PRINT: "print",
    EDIT: "edit",
    DELETE: "delete",
    PAID: "paid",
}

export const EXPENSE_SCHEMAS = {
    txnExpenseRequestId: "",
    totalExpense: "",
    totalExpenseBaht: "",
    subject: "",
    expenseDate: "",
    // description: "",
    foreignCurrencyStatus: "N",
    foreignCurrencyId: "",
    currencyRate: "",
    // attachFiles: "",
    // images: "",
    startMiles: "",
    endMiles: "",
    distance: "",
    fuelExpense: "",
    fuelExpenseStatus: "N",
    totalNights: 0,
    accommodationExpense: 0,
    accommondationStatus: "N",
    numberOfPersonInMeeting: "",
    meetingExpense: "",
    meetingExpenseStatus: "N",
    parkingExpense: "",
    travelExpense: "",
    tollFreeExpense: "",
    travelExpenseStatus: "N",
    numberOfPersonInEntertainment: "",
    entertainmentExpense: "",
    entertainmentExpenseStatus: "N",
    staffAllowanceExpense: "",
    staffAllowanceStatus: "N",
    trainingTitle: "",
    trainingHours: "",
    trainingMinutes: "",
    numberOfParticipants: "",
    trainingExpense: "",
    trainingStatus: "N",
    otherDiscription: "",
    otherExpense: "",
    othersStatus: "N",
}


export const EXPENSE_VALIDATE = Yup.object().shape({
    subject: Yup.string().required('Subject is required'),
    expenseDate: Yup.date().required('Expense date is required'),
    // description: Yup.string().required('Description is required'),
    fuelExpenseStatus: Yup.string().required('FuelExpenseStatus is required'),

    foreignCurrencyId: Yup.string().when("foreignCurrencyStatus", {
        is: (val) => val === 'Y',
        then: () => Yup.string().required('Foreign Currency is required'),
        otherwise: () => Yup.string().notRequired(),
    }),

    currencyRate: Yup.string().when("foreignCurrencyStatus", {
        is: (val) => val === 'Y',
        then: () => Yup.number().positive("must be a positive number").required('Exchange Rate is required'),
        otherwise: () => Yup.string().notRequired(),
    }),

    startMiles: Yup.number().when("fuelExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Start miles is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    endMiles: Yup.number().when("fuelExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('End miles is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    distance: Yup.number().when("fuelExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Distance miles is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    fuelExpense: Yup.number().when("fuelExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Fuel Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),

    // * accommodation
    totalNights: Yup.number().when("accommondationStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Total Nights is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    accommodationExpense: Yup.number().when("accommondationStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Accommodation Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),

    // * meeting
    meetingExpense: Yup.number().when("meetingExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Meeting Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    numberOfPersonInMeeting: Yup.number().when("meetingExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('No. of Participants is require'),
        otherwise: () => Yup.string().notRequired(),
    }),

    // * travel
    parkingExpense: Yup.number().when("travelExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Parking Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    travelExpense: Yup.number().when("travelExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Travel Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    tollFreeExpense: Yup.number().when("travelExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Toll Fee Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),

    // * entertain
    numberOfPersonInEntertainment: Yup.number().when("entertainmentExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('No. of Participants is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    entertainmentExpense: Yup.number().when("entertainmentExpenseStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Entertainment Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),

    // * staffAllowance
    staffAllowanceExpense: Yup.number().when("staffAllowanceStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Staff Allowance Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),

    // * training
    trainingTitle: Yup.number().when("trainingStatus", {
        is: (val) => val === "Y",
        then: () => Yup.string().required('Training Title is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    trainingExpense: Yup.number().when("trainingStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Training Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    trainingHours: Yup.number().when("trainingStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Training Hours is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    trainingMinutes: Yup.number().when("trainingStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Training Minutes is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    numberOfParticipants: Yup.number().when("trainingStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Toll Fee Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),

    otherDiscription: Yup.number().when("othersStatus", {
        is: (val) => val === "Y",
        then: () => Yup.string().required('Training Minutes is require'),
        otherwise: () => Yup.string().notRequired(),
    }),
    otherExpense: Yup.number().when("othersStatus", {
        is: (val) => val === "Y",
        then: () => Yup.number().positive('must be a positive number').required('Toll Fee Expense is require'),
        otherwise: () => Yup.string().notRequired(),
    }),




});



